// libraries
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import RoundedBox from '/react4xp/components/RoundedBox'
import Image from '/react4xp/components/Image'

// css
import './index.scss'

// types
export interface QuotationCardProps {
    className?: string
    isAnimated?: boolean
    color?: 'green' | 'beige' | 'green-light'
    invert?: boolean
    image?: {
        src?: string
        alt?: string
    }
    quote?: string
    author?: {
        name?: string
        connection?: string
    }
}

export default function QuotationCard({
    className,
    isAnimated,
    color,
    invert,
    image,
    quote,
    author
}: QuotationCardProps) {
    return (
        <Section className={clsx('quote-component', className)}>
            <div
                className='container'
                data-stagger-up={isAnimated ? 'true' : 'false'}
            >
                <RoundedBox bgColor={color}>
                    <div className='row'>
                        <div className='col-lg-10 offset-lg-1'>  
                            <div className={clsx(
                                'quote-component__wrapper',
                                invert && 'quote-component__wrapper--invert'
                            )}>

                                <div className='quote-component__image'>
                                    {image && (
                                        <Image
                                            src={{
                                                src: image?.src || '',
                                                width: 250,
                                                height: 250
                                            }}
                                            alt={image?.alt || ''}
                                            className='cover'
                                            sizes='250px'
                                        />
                                    )}
                                </div>

                                <div className='quote-component__infos'>

                                    {quote && (
                                        <h2 className='h2'>
                                            – {quote}
                                        </h2>
                                    )}

                                    {author && (
                                        <div className='quote-component__author body'>
                                            <p>
                                                {author.name && author.name}

                                                {author.connection && (
                                                    <>
                                                        , {author.connection}
                                                    </>
                                                )}
                                            </p>
                                        </div>
                                    )}

                                </div>

                            </div>
                        </div>
                    </div>
                </RoundedBox>
            </div>
        </Section>
    )
}